import { render } from "./ReservationRecord.vue?vue&type=template&id=e75364b6&scoped=true"
import script from "./ReservationRecord.vue?vue&type=script&lang=js"
export * from "./ReservationRecord.vue?vue&type=script&lang=js"

import "./ReservationRecord.vue?vue&type=style&index=0&id=e75364b6&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e75364b6"]])

export default __exports__